import React, { FC, useState } from "react";
import styles from "./home.module.scss";
import { CloseOutlined, MailOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import { Col, Row } from "antd";
import { AveliosButton } from "../common-layout/avelios-button";
import { useRouter } from "next/router";
import { useCurrentUser } from "../../helpers/utils";

export const UnverifiedAccountAlert: FC = () => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const { currentUser } = useCurrentUser();
  const unverified = !!currentUser?.id && !currentUser?.verified;
  const email = currentUser?.email;

  const [canceled, setCanceled] = useState<boolean>(false);

  return unverified && !canceled ? (
    <div className={styles.reservedAppointment}>
      <span className={styles.cancel} onClick={() => setCanceled(true)}>
        <CloseOutlined />
      </span>
      <Row>
        <Col className={styles.icon}>
          <MailOutlined />
        </Col>
        <Col>
          <p className={styles.reservedAppointmentTitle}>
            {formatMessage({ id: "home.unverified-user" })}
          </p>
          <p>
            {formatMessage(
              { id: "home.unverified-user.description" },
              { email }
            )}
          </p>
          <AveliosButton
            type={"primary"}
            onClick={() => {
              router.push({
                pathname: "/user",
              });
            }}
          >
            {formatMessage({ id: "home.unverified-user.verify" })}
          </AveliosButton>
        </Col>
      </Row>
    </div>
  ) : null;
};
